// import { push } from '@lagunovsky/redux-react-router'
import { CollectivityActionConstant } from 'rpqs/reducers/CollectivityReducer'
import { collectivitiesData } from 'rpqs/ressource/data'
// import i18n from 'simple-react-i18n'
// import ToastrAction from 'toastr/actions/ToastrAction'

// TODO: use genericPromise2 and thunk

// const builderError403 = (dispatch) => () => {
//     dispatch(ToastrAction.warning(i18n.habilitationError))
//     dispatch(push('/rpqs'))
// }

const CollectivityAction = {
    fetchCollectivity: id => dispatch => dispatch(CollectivityActionConstant.collectivity(collectivitiesData.find((collectivity) => collectivity.id === id))),
    fetchCollectivities: () => dispatch => dispatch(CollectivityActionConstant.collectivities(collectivitiesData)),
    fetchManagementEntity: (collectivityId, entityId) => dispatch => {
        const collectivity = collectivitiesData?.find((c) => c.id === collectivityId)
        dispatch(CollectivityActionConstant.managementEntity(collectivity?.managementEntities?.find((entity) => entity.id === entityId)))
    },
    updateEntity: (newEntity) => dispatch => {
        dispatch(CollectivityActionConstant.managementEntity(newEntity))
    },
    fetchZones: (collectivityId, entityId) => dispatch => {
        const collectivity = collectivitiesData?.find((c) => c.id === collectivityId)
        const entity = collectivity?.managementEntities?.find((e) => e.id === entityId)
        dispatch(CollectivityActionConstant.zones(entity?.zones))
    },
    updateZone: (newZone) => dispatch => {
        dispatch(CollectivityActionConstant.zone(newZone))
    },
    updateZones: (newZones) => dispatch => {
        dispatch(CollectivityActionConstant.zones(newZones))
    },
}

export default CollectivityAction